import React from 'react';
import enhance from './CampaignAnalytics.enhancer';
import { dealStatuses } from '../../constants';
import { round, map, orderBy } from 'lodash';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Button from '@material-ui/core/Button';
import { campaignStatuses, contentTypes } from '../../constants';
import moment from 'moment';
import Dialog from '@material-ui/core/Dialog';
import { getCountryValueFromKey } from '../../helpers/countryHelper';
import HpTooltip from '../../components/shared/components/hpTooltip';
import { Line, Pie } from 'react-chartjs-2';
import CountUp from 'react-countup';
import { chartColors } from '../../constants';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

class CampaignAnalytics extends React.Component {
  constructor() {
    super();

    this.initialState = {
      totalCampaignPayout: 0,
      totalCampaignViews: 0,
      viewsPerDollar: 0,
      totalViews: 0,
      campaign: {},
      campaignContent: []
    };

    this.state = {
      ...this.initialState
    };
  }

  componentDidMount = async () => {
    const campaignSnapshot = await this.props.firestore.get({
      collection: 'campaigns',
      storeAs: 'campaignAnalytics',
      doc: this.props.campaignId
    });
    if (!campaignSnapshot.exists) {
      this.setState({
        campaignNotFound: true
      });
    } else {
      const campaign = campaignSnapshot.data();
      this.setState({
        campaign
      });

      const dealSnapshots = await this.props.firestore
        .collection('deals')
        .where('campaignId', '==', this.props.campaignId)
        .get();

      const deals = dealSnapshots.docs.map(dealSnapshot => {
        return { ...dealSnapshot.data(), id: dealSnapshot.id };
      });

      const completedDeals = deals.filter(
        deal => deal.status === dealStatuses.COMPLETE
      );

      const totalCampaignPayout = completedDeals.reduce(
        (totalPayout, deal) =>
          parseFloat(deal.currentProposal.payout) + parseFloat(totalPayout),
        0
      );

      const viewsPerDollar =
        totalCampaignPayout && campaign.statistics
          ? round(campaign.statistics.totalViews / totalCampaignPayout)
          : 0;

      this.setState({
        // totalCampaignPayout: totalCampaignPayout ? totalCampaignPayout.toLocaleString() : 0,
        viewsPerDollar: viewsPerDollar,
        // totalViews: this.props.campaign.statistics ? this.props.campaign.statistics.totalViews.toLocaleString() : 0
        totalCampaignPayout,
        // viewsPerDollar,
        totalViews: campaign.statistics ? campaign.statistics.totalViews : 0
      });

      // get historial campaign views
      // if the historical views for this campaign are not on the state, get them on the state
      if (!this.props.campaignHistoricalViews) {
        this.props.getCampaignHistoricalViewsHandler(this.props.campaignId);
      }

      const dealsWithUsers = await this.getDealsWithUsers(completedDeals);

      this.generatePieChartData(dealsWithUsers);
      this.loadContentData(dealsWithUsers);
    }
  };

  getDealsWithUsers = async deals => {
    const requests = deals.map(async deal => {
      return await new Promise(async resolve => {
        const userDoc = await this.props.firestore
          .collection('users')
          .doc(deal.influencerId)
          .get();

        return resolve({
          ...deal,
          user: userDoc.data()
        });
      });
    });

    return Promise.all(requests).then(dealsWithUsers => {
      return dealsWithUsers;
    });
  };

  loadContentData = async deals => {
    const requests = deals.map(async deal => {
      return await new Promise(async resolve => {
        const contentSnapshots = await this.props.firestore
          .collection('deals')
          .doc(deal.id)
          .collection('content')
          .get();

        const contents = contentSnapshots.docs.map(contentSnapshot => {
          return { ...contentSnapshot.data(), id: contentSnapshot.id };
        });

        resolve({
          ...deal,
          contents: [...contents]
        });
      });
    });

    return Promise.all(requests).then(content => {
      this.setState({
        campaignContent: content
      });
    });
  };

  generatePieChartData = async deals => {
    const labels = [];
    const data = [];
    const dealsData = [];
    const backgroundColor = [];

    deals.map((deal, index) => {
      labels.push(deal.user.displayName);
      data.push(deal.statistics ? deal.statistics.totalViews : 0);
      backgroundColor.push(chartColors[(index + 1) % 5]);
      dealsData.push({
        ...deal,
        influencerName: deal.user.displayName
      });
    });

    this.setState({
      pieChartData: {
        labels,
        datasets: [
          {
            data,
            backgroundColor
          }
        ]
      },
      dealsData
    });
  };

  render() {
    const {
      totalCampaignPayout,
      viewsPerDollar,
      totalViews,
      pieChartData,
      dealsData,
      campaign,
      campaignContent
    } = this.state;

    const { classes, profile, campaignHistoricalViews } = this.props;

    // form data for line chart
    let data;
    let labels;
    const DAYS_BACK = 30;

    if (campaignHistoricalViews && campaignHistoricalViews.length) {
      const sortedStats = orderBy(
        campaignHistoricalViews,
        stat => stat.timestamp
      );

      const dataTemp = map(sortedStats, 'totalViews').splice(DAYS_BACK);
      data = dataTemp.map((views, index) => {
        if (index === 0 || views > dataTemp[index - 1]) {
          return views;
        }

        return undefined;
      });

      labels = map(sortedStats, 'timestamp').splice(DAYS_BACK);
    }

    const lineChartData = {
      labels,
      datasets: [
        {
          label: `${campaign.name} views`,
          backgroundColor: '#22c26e',
          borderColor: '#22c26e',
          data,
          fill: false,
          spanGaps: true
        }
      ]
    };

    const lineChartOptions = {
      responsive: true,
      aspectRatio: 2
    };

    return (
      <React.Fragment>
        <div className={classes.layout}>
          <Grid container xs={12} direction="column">
            <Grid container direction="row">
              <Grid item container sm={4} xs={12}>
                <Paper className={classes.leftSection}>
                  <Typography
                    variant="h2"
                    align="center"
                    justify="center"
                    className={classes.vPerDAmount}
                  >
                    <CountUp
                      end={totalCampaignPayout}
                      separator={','}
                      duration={1}
                    />
                  </Typography>
                  <Typography align="center" justify="center">
                    Total Spent
                  </Typography>
                </Paper>
                <Paper className={classes.totalViewsContainer}>
                  <Typography
                    variant="h2"
                    align="center"
                    justify="center"
                    className={classes.vPerDAmount}
                  >
                    <CountUp end={totalViews} separator={','} duration={1} />
                  </Typography>
                  <Typography align="center" justify="center">
                    Total Views
                  </Typography>
                </Paper>
                <Paper className={classes.totalSpentContainer}>
                  <Typography
                    variant="h2"
                    align="center"
                    justify="center"
                    className={classes.vPerDAmount}
                  >
                    <CountUp
                      end={viewsPerDollar}
                      separator={','}
                      duration={1}
                    />
                  </Typography>
                  <Typography align="center" justify="center">
                    Views / Dollar Spent
                  </Typography>
                </Paper>
              </Grid>
              <Grid item container sm={8} xs={12}>
                <Paper className={classes.rightSection}>
                  {lineChartData && data && data.length > 0 && (
                    <Line
                      data={lineChartData}
                      options={lineChartOptions}
                      height={null}
                      width={null}
                    />
                  )}
                  {(!lineChartData || !data || !data.length) && (
                    <Typography>No Historical Data</Typography>
                  )}
                </Paper>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              className={classes.dealAnalyticsContainer}
            >
              <Grid item container sm={12} xs={12}>
                <Paper className={classes.dealsBreakdownPaper}>
                  <Typography
                    align="center"
                    variant="h5"
                    className={classes.title}
                  >
                    Deals Breakdown
                  </Typography>
                  <div className={classes.dealsBreakdownContainer}>
                    <div className={classes.pieChartContainer}>
                      <Pie data={pieChartData} width={340} height={340} />
                    </div>
                    <div className={classes.dealsTable}>
                      <Table className={classes.table}>
                        <TableBody>
                          <TableRow>
                            <TableCell className={classes.headerCell}>
                              Influencer
                            </TableCell>
                            <TableCell className={classes.headerCell}>
                              Commission
                            </TableCell>
                            <TableCell className={classes.headerCell}>
                              Reach
                            </TableCell>
                            <TableCell className={classes.headerCell}>
                              View/Dollar Spent
                            </TableCell>
                          </TableRow>
                          {dealsData &&
                            dealsData.length > 0 &&
                            dealsData.map(row => (
                              <TableRow
                                key={row.id}
                                className={classes.tableRow}
                              >
                                <TableCell
                                  component="th"
                                  scope="row"
                                  className={classes.tableCell}
                                >
                                  {row.influencerName}
                                </TableCell>
                                <TableCell
                                  component="th"
                                  scope="row"
                                  className={classes.tableCell}
                                >
                                  {row.currentProposal.payout}
                                </TableCell>
                                <TableCell
                                  component="th"
                                  scope="row"
                                  className={classes.tableCell}
                                >
                                  {row.statistics
                                    ? row.statistics.totalViews
                                    : 0}
                                </TableCell>
                                <TableCell
                                  component="th"
                                  scope="row"
                                  className={classes.tableCell}
                                >
                                  {row.currentProposal.payout && row.statistics
                                    ? round(
                                        campaign.statistics.totalViews /
                                          row.currentProposal.payout
                                      )
                                    : 'N/A'}
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </div>
                  </div>
                </Paper>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              className={classes.dealAnalyticsContainer}
            >
              <Grid item container sm={12} xs={12}>
                {campaignContent && campaignContent.length && (
                  <Paper className={classes.campaignContentPaper}>
                    <Typography
                      align="center"
                      variant="h5"
                      className={classes.title}
                    >
                      Content Breakdown
                    </Typography>
                    {campaignContent.map(deal =>
                      deal.contents.map(content => (
                        <Grid
                          item
                          container
                          direction="column"
                          sm={6}
                          xs={12}
                          className={classes.campaignContentContainer}
                        >
                          <Typography>
                            {`Posted on by ${moment(
                              content.timestamp.toDate()
                            ).format('MM/DD/YYYY')}  ${deal.user.displayName}`}
                          </Typography>
                          <div>
                            <Typography display="inline">Views: </Typography>
                            <Typography display="inline">
                              {` ${
                                content.totalViews
                                  ? content.totalViews.toLocaleString()
                                  : ''
                              }`}
                            </Typography>
                          </div>
                          <div className={classes.youtubeVideoUpload}>
                            <iframe
                              className={classes.iframeContainer}
                              src={`https://www.youtube.com/embed/${content.videoId}`}
                              frameborder="0"
                              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                              allowfullscreen
                            />
                          </div>
                        </Grid>
                      ))
                    )}
                  </Paper>
                )}
              </Grid>
            </Grid>
            <Typography>* View counts updated every 24 hours</Typography>
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

export default enhance(CampaignAnalytics);



// WEBPACK FOOTER //
// ./src/components/campaign/CampaignAnalytics.js